import styled, { css } from 'styled-components';

export const ModalContent = styled.div<{ isUpload?: boolean }>`
  .ant-form-item {
    margin: 0;
  }

  .ant-steps-item-wait {
    opacity: 0.5;

    .ant-select-selection-search-input {
      pointer-events: none !important;
      outline: none;
      text-indent: -9999px;
    }
  }

  .action-modal-item-error,
  .ant-form-item-explain-error {
    font-size: 0.8rem;
    color: red;
  }

  .action-modal-description-text {
    font-size: 0.85rem;
    color: ${({ theme }) => theme.colors.text};
  }

  .ant-divider {
    margin: 16px 0;
  }

  .ant-alert {
    p {
      color: ${({ theme }) => theme.colors.text};
    }
    .anticon {
      font-size: 1.2rem;
    }
    .ant-alert-message {
      font-size: 0.95rem;
    }
    .ant-alert-description {
      font-size: 0.9rem;
    }
  }

  .action-modal-confirm-request {
    color: ${({ theme }) => theme.colors.text};
  }
`;

export const ModalFooter = styled.footer<{ totalDevices: number }>`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: ${({ totalDevices }) =>
    totalDevices > 0 ? 'space-between' : 'flex-end'};

  .action-modal-footer-total-devices {
    font-size: 0.85rem;
    opacity: 0.6;
    color: ${({ theme }) => theme.colors.text1};
  }

  @media (max-width: 360px) {
    ${({ totalDevices }) =>
      totalDevices > 0 &&
      css`
        justify-content: center;
      `}

    .action-modal-footer-total-devices {
      margin-bottom: 8px;
    }
  }
`;
